const actionPrefix = (actionType) => `LoadingSpinner/${actionType}`;

export const API_CALL_FINISHED = actionPrefix`API_CALL_FINISHED`;
export const apiCallFinished = (payload) => ({ type: API_CALL_FINISHED, payload });

export const COUNTED_API_CALL_FINISHED = actionPrefix`COUNTED_API_CALL_FINISHED`;
export const countedApiCallFinished = (payload) => ({ type: COUNTED_API_CALL_FINISHED, payload });

export const loadingSpinnerActions = {
  apiCallFinished,
  countedApiCallFinished,
};
